import { DateTime } from 'luxon'

const MAX_MULTI_DAY_SELECTED_PARKING = 5
const MAX_NOTES_LENGTH = 200
const REGEX_HTTP_URL = /\(https?:\/\/(www.)?[-a-zA-Z0-9@:%._+~#=]{1,256}.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)('')?/g
const REGEX_ENDLINE = /\n/g
// eslint-disable-next-line no-useless-escape
const REGEX_EMAIL = /[a-zA-Z0-9\-]+[\._]?[a-zA-Z0-9]+[@][\w\-]+[.]\w{2,3}/

const ONE_SECOND = 1000
const GOOGLE_MAP_URL = 'https://www.google.com/maps'
const DEFAULT_FLOOR_IMAGE = { url: 'static_map.png', size: [] }
const IMAGE_BOUNDS = [[0, 0], [1000, 1000]]
const CENTER = [0, 0]
const EIGHT_AM = DateTime.local().set({ hour: 8, minute: 0, second: 0 }).toJSDate() // Js Date 
const FIVE_PM = DateTime.local().set({ hour: 17, minute: 0, second: 0 }).toJSDate() // Js Date 

const PARKING_RESERVATION = 'ParkingReservation'
const DESK_RESERVATION = 'Workplace::DeskReservation'
const ROOM_RESERVATION = 'Workplace::RoomReservation'

const VISIT = 'VISIT'
const IMPORT = 'IMPORT'

const OFFLINE = 'OFFLINE'
const SYNCHRONIZED = 'SYNCHRONIZED'
const SYNCHRONIZING = 'SYNCHRONIZING'
const DEFAUTL_QR_START_CODE = 'parso_'
const DEFAUTL_BASE64_START_CODE = 'base64:'
const DEFAUTL_CR_START_CODE = 'CI-'

const COMES = 'COMES'
const COMPANIES = 'COMPANIES'
const DEFAULT_AUTOCOMPLETE = { id: -1, name: '' }

const DEFAULT_GUEST = {
  first_name: '',
  last_name_one: '',
  email: '',
  reason: '',
  identification: '',
  invitation_date: '',
  invitation_time: '',
  comes_from: '',
  building_id: ''
}

const DEFAULT_BLACK_LIST_USER = {
  details: '',
  first_name: '',
  identification: '',
  last_name_one: '',
  last_name_two: '',
  solutions: '',
}

const MODEL_DETECTION_PATH = './detection.onnx'; 
const MODEL_EXTRACTION_PATH = './extraction.onnx'; 
const EXTRACTION_CLASS_LABELS = ['first_name', 'identification', 'last_name', 'last_name_two'];
const MODEL_INPUT_SHAPE = [1, 3, 640, 640];
const CONFIDENCE_THRESHOLD = 0.50; // Umbral de confianza general para dibujar una caja.
const IOU_THRESHOLD = 0.50; // Umbral para la supresión de no máximos (NMS).
const BORDER_CONFIDENCE_THRESHOLD = 0.85; // Umbral de confianza para la captura automática.
const SHARPNESS_THRESHOLD = 85; // Umbral de nitidez para la captura automática.
const MIN_ASPECT_RATIO = 1.3;   // Proporción mínima (ancho/alto) de una cédula. perfected horizontal: 1.6.
const MIN_AREA_RATIO = 0.45;    // Debe ocupar al menos el 50% del área del visor
const DETECT_INTERVAL_MS = 1000;
const FIVE_SECONDS = 5;


const OPTIONS_IMAGE_COMPRESSION = {
  maxSizeMB: 0.2,       // Límite de tamaño generoso de 500KB para un ID
  useWebWorker: true,   // Esencial para no bloquear la UI
  maxWidthOrHeight: 400, // Redimensiona a un tamaño razonable para OCR
  initialQuality: 0.6,  // Si usas JPEG, mantén una calidad alta para proteger el texto
};

const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';
const UPDATE = 'UPDATE';
const WAITING = 'WAITING';
const MODEL_LOADING = 'MODEL_LOADING';
const MODEL_READY = 'MODEL_READY';
const DETECTION_RESULT = 'DETECTION_RESULT';
const EXTRACTION_RESULT = 'EXTRACTION_RESULT';
const EXTRACTION_ERROR = 'EXTRACTION_ERROR'
const FALLBACK_REQUIRED = 'FALLBACK_REQUIRED';

const INIT ='INIT';
const DETECT ='DETECT';
const EXTRACT ='EXTRACT';

const WARNING = 'WARNING';
const INFO = 'INFO';
const UNSUPPORTED = 'UNSUPPORTED';
const OK = 'OK';

const ID_CAMERA_SCANNING = 'ID_CAMERA_SCANNING';
const ID_CAMERA_QR = 'ID_CAMERA_QR';
const ID_CAMERA_PHOTO = 'ID_CAMERA_PHOTO';
const ID_CAMERA_MRZ = 'ID_CAMERA_MRZ';

const REGEX_LICENSE_PLATE = /^[a-zA-Z0-9]{1,10}$/
const MAX_LICENSE_PLATE_LENGTH = 10



export {
  MAX_NOTES_LENGTH,
  MAX_LICENSE_PLATE_LENGTH,
  REGEX_LICENSE_PLATE,
  DEFAUTL_BASE64_START_CODE,
  DEFAUTL_CR_START_CODE,
  WARNING,
  INFO,
  UNSUPPORTED,
  OK,
  FIVE_SECONDS,
  INIT,
  DETECT,
  EXTRACT,
  EXTRACTION_RESULT,
  EXTRACTION_ERROR,
  FALLBACK_REQUIRED,
  SUCCESS,
  UPDATE,
  MODEL_LOADING,
  MODEL_READY,
  DETECTION_RESULT,
  ERROR, 
  WAITING,
  OPTIONS_IMAGE_COMPRESSION,
  MIN_ASPECT_RATIO,
  MIN_AREA_RATIO,
  EXTRACTION_CLASS_LABELS,
  DETECT_INTERVAL_MS,
  SHARPNESS_THRESHOLD,
  MODEL_DETECTION_PATH,
  MODEL_EXTRACTION_PATH,
  MODEL_INPUT_SHAPE,
  CONFIDENCE_THRESHOLD,
  IOU_THRESHOLD,
  BORDER_CONFIDENCE_THRESHOLD,
  DEFAUTL_QR_START_CODE,
  MAX_MULTI_DAY_SELECTED_PARKING,
  DEFAULT_BLACK_LIST_USER,
  DEFAULT_AUTOCOMPLETE,
  PARKING_RESERVATION,
  DESK_RESERVATION,
  ROOM_RESERVATION,
  DEFAULT_FLOOR_IMAGE,
  GOOGLE_MAP_URL,
  REGEX_HTTP_URL,
  REGEX_ENDLINE,
  DEFAULT_GUEST,
  IMAGE_BOUNDS,
  REGEX_EMAIL,
  ONE_SECOND,
  OFFLINE,
  SYNCHRONIZED,
  SYNCHRONIZING,
  COMES,
  COMPANIES,
  EIGHT_AM,
  FIVE_PM,
  CENTER,
  IMPORT,
  VISIT,
  ID_CAMERA_SCANNING,
  ID_CAMERA_QR,
  ID_CAMERA_PHOTO,
  ID_CAMERA_MRZ
}
